module.exports = __webpack_public_path__ + "static/img/tab_bg@2x.c325d4bb.png";